module.exports = __webpack_public_path__ + "img/submit.766f66f6.png";